{
  "title": "Moonbeam",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level evocation",
  "level": 2,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S, M (several seeds of any moonseed plant and a piece of opalescent feldspar)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "A silvery beam of pale light shines down in a 5-foot radius, 40-foot-high cylinder centered on a point within range. Until the spell ends, dim light fills the cylinder.",
    "When a creature enters the spell’s area for the first time on a turn or starts its turn there, it is engulfed in ghostly flames that cause searing pain, and it must make a Constitution saving throw. It takes 2d10 radiant damage on a failed save, or half as much damage on a successful one.",
    "A shapechanger makes its saving throw with disadvantage. If it fails, it also instantly reverts to its original form and can’t assume a different form until it leaves the spell’s light.",
    "On each of your turns after you cast this spell, you can use an action to move the beam up to 60 feet in any direction.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the damage increases by 1d10 for each slot level above 2nd."
  ],
  "spellLists": ["druid"]
}
